import { ComponentDataSourceService } from '../component-data-source.service';
import { Observable } from 'rxjs';
import { DataSourceFunction } from '../component-data-source.service';
import { LoadDataParams } from '../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../environment/environment';

export const yearly_sticker_status = (service: ComponentDataSourceService): DataSourceFunction => ({
  name: 'yearly_sticker_status',
  description: 'Get yearly sticker completion status for users',
  execute: (params?: LoadDataParams): Observable<any> => {
    const queryParams: any = {};
    if (params?.filters) {
      const userFilter = params.filters.find(f => f.column === 'userId');
      const yearFilter = params.filters.find(f => f.column === 'year');
      if (userFilter) queryParams.userId = userFilter.value;
      if (yearFilter) queryParams.year = yearFilter.value;
    }
    
    return service.http.get(`${environment.apiUrl}/sticker/status`, { params: queryParams });
  }
}); 